var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['row', _vm.margin || 'mb-4']},[_c('label',{class:`col-sm-${_vm.cols || 4} font-weight-bold`,attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.labelText)+":")]),_vm._v(" "),_c('div',{class:`col-sm-${12 - (_vm.cols || 4)}`,attrs:{"id":_vm.id},domProps:{"innerHTML":_vm._s(_vm.value)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }